import { util } from 'echarts';
import type { PresetMode } from '../..';
import { type Option } from '../../../core/option';
import { type ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import { FONT_LEVEL_LIST, FONT_SIZE_LIST, fontColor } from '../../mobile/static/font';

export function preprocessXAxis(option: Parameters<ThemeParser>[0]) {
  option.xAxis = normalizeToArray(option.xAxis) as Option['xAxis'];
}

export function defaultXAxisOpt(mode: PresetMode) {
  /** x轴两侧各有24的安全边距 */
  const DVPADDINGVALUE = 24;
  return {
    dvPadding: [DVPADDINGVALUE, DVPADDINGVALUE],
    axisTick: {
      show: false
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: mode === 'light' ? '#808080' : '#666666',
        width: 0.5
      }
    },
    splitLine: {
      show: false,
      interval: 1
    },
    axisLabel: {
      show: true,
      dvAlignEdge: false,
      /**  */
      dvLayout: 3,
      /**  */
      dvLayoutTakeEffectGreaterThan: 'auto',
      color: fontColor(FONT_LEVEL_LIST.LEVEL2, mode),
      fontSize: FONT_SIZE_LIST.axisLabel,
      lineHeight: 12,
      margin: 6
    },
    axisPointer: {
      animation: false,
      show: true,
      triggerEmphasis: true,
      z: 0,
      lineStyle: {
        type: 'solid',
        color: mode === 'light' ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)',
        width: 1.5
      },
      shadowStyle: {
        dvMaxWidth: 48,
        color: mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        show: true,
        fontSize: 10,
        margin: 5,
        fontFamily: 'sans-serif',
        lineHeight: 14,
        color: mode === 'light' ? '#fff' : '#000',
        backgroundColor: mode === 'light' ? '#000' : '#fff',
        /**
         * @description 设计师根据x轴标签效果调试得出的标签文本内边距
         */
        // eslint-disable-next-line no-magic-numbers
        padding: [0, 3, 0, 3],
        borderRadius: 4
      }
    }
  } as Option['xAxis'] & {
    axisPointer: {
      triggerEmphasis: boolean;
    };
  };
}

export function parseXAxis(
  option: Parameters<ThemeParser>[0],
  defaultXAxis: Parameters<ThemeParser>[0]['xAxis']
) {
  (option.xAxis as unknown as []).forEach((xAxis, index) => {
    option.xAxis[index] = util.merge(util.clone(defaultXAxis), xAxis, true);
  });
}

export function xAxisThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preprocessXAxis(option);
  parseXAxis(option, defaultXAxisOpt(themeMode));
}
